import * as React from "react"
import { SEO } from "gatsby-plugin-seo";
import { gsap, Power3 } from "gsap";
import { SplitText } from "gsap/SplitText"
import pimage from "../images/studionft-top.jpg";
import pimage1 from "../images/studionft-1.jpg";
import pimage2 from "../images/studionft-2.jpg";
import Footer from "../components/Footer";
import ProjectCanvas from "../components/ProjectCanvas";
import pvideo from "../video/studionft-2.mp4";
import nextprojectSVG from "../images/next-project.svg";
import customNav from "../components/customNav";

var imagesLoaded = require('imagesloaded');
gsap.registerPlugin(SplitText);

//nav
let siteNav = new customNav();



class NamikoPage extends React.Component {

    constructor(props) {
        super(props);

        this.loadImagesHandler = this.loadImages.bind(this);
    }

    componentWillUnmount() {
        window.removeEventListener("fontsLoaded", this.loadImagesHandler);
        this.canvas.destroy();
    }

    initAni() {

        if (typeof window.ss !== 'undefined') {
            window.ss.update();
        }

        setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
        },100);




        let title = new SplitText('.project__title-l', {type: "chars"});


        const scrollLetters = title.chars
        let randomValues = []

        scrollLetters.forEach(letter => {
            const val = Math.random()
            randomValues.push(val)
        })

        function randomLetterScroll() {

            if (document.querySelector(".project__title") != null) {

                const distance = document.querySelector(".project__top").getBoundingClientRect().top
                scrollLetters.forEach((letter, index) => {

                    if (
                        letter.getBoundingClientRect().top < window.innerHeight + 200 &&
                        letter.getBoundingClientRect().top + letter.clientHeight > -200
                    ) {

                        let myVal = randomValues[index];

                        gsap.to(letter,  {
                            duration: 1,
                            y: `${Math.abs(distance * myVal / 15)}px`,
                            overwrite: 'auto'
                        })

                    }
                })

                window.addEventListener('scroll', randomLetterScroll);
            }
        }

        if (window.matchMedia('(min-width:480px)').matches) {
            randomLetterScroll();
        }

        window.ss.on('scroll', (args) => {
            window.dispatchEvent(new Event('scroll'));
            if (args.scroll.y > 104) {
                document.querySelector('.site__scroll').classList.add('scrolled');
            } else {
                document.querySelector('.site__scroll').classList.remove('scrolled');
            }
        });


        const introTimeline = new gsap.timeline({paused: true});

        introTimeline.set(".home__title-col", { perspective: 200,})
        introTimeline.set(".project__cat-wrap", { perspective: 200,})





        var aniP = {
            opacity: 0,
            duration: 1.0,
            y: 150,
            scaleY: 2,
            stagger: 0.15,
            transformOrigin: "0% 0% 0%",
            rotation: 15,
            rotationX: -25,
            ease: Power3.easeInOut,
            clearProps: true
        }

        introTimeline
            .add('start')
            .from('.project__title',aniP,'start')
            .from('.project__cat',aniP,'start')
            .from('.site__canvas',{
                opacity: 0,
                duration: 1,
                delay: .5,
                ease: Power3.easeInOut,
            },'start')
            .add(function () {
                window.dispatchEvent(new Event('resize'));
            });



        setTimeout(function () {
            introTimeline.play();
            console.log('go ani go')

        },100);


    }

    loadImages() {
        const preloadImages = new Promise((resolve, reject) => {
            imagesLoaded(document.querySelectorAll("img"), { background: true }, resolve);
        });
        let allDone = [preloadImages];



        Promise.all(allDone).then(()=>{

            console.log('enmei - images loaded')

            let targ = document.querySelector('.site__canvas');
            this.canvas = new ProjectCanvas(targ);
            this.canvas.init();

            this.initAni()

            gsap.to('.site__canvas-wrap', {
                duration: 0.5,
                opacity: 1,
                delay: .5
            });

            gsap.to('main', {
                duration: 0.5,
                opacity: 1,
                delay: .5
            });

            document.querySelector('.loader').classList.add('ready');

            let globalTimeline = new gsap.timeline();

            globalTimeline.to('.loader', {
                duration: .5,
                opacity: 0
            })
                .add(function () {

                    document.querySelector('.loader').style.display = 'none';
                    document.querySelector('.site__nav').classList.add('show');
                    document.querySelector('.site__mode').classList.add('show');
                    document.querySelector('.site__scroll').classList.add('show');


                })




        });
    }

    componentDidMount() {

        if (typeof window !== "undefined") {

            if (!this.props.firstAppLoad) {
                console.log('index - app already inizialized')
                this.loadImages();
            }

            //ho finito di montare il layout
            window.addEventListener('fontsLoaded', this.loadImagesHandler, false);

            document.getElementById('site__mode').addEventListener('click',function (e) {

                e.preventDefault();

                if (document.body.classList.contains('dark-mode')) {
                    this.canvas.setTextureDark();
                } else {
                    this.canvas.setTextureLight();
                }

            }.bind(this));


        }
    }

    render() {

        return(
            <>
                <SEO title="Studio NFT" description="Studio NFT - blockchain tech" pagePath="studionft" />

                <div className="project__top">
                    <div className="container-fluid h-100">
                        <div className="row h-100 align-items-center justify-content-center">
                            <div className="col-12  home__title-col ">
                                <h1 className="home__title home__title--3 m-0 project__title text-center">
                                    <div className="project__title-l">Studio<br />NFT</div></h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row justify-content-center project__cat-wrap">
                        <div className="col-12 col-lg-8 project__cat">
                            <h3 className="project__cat-t">WEBSITE</h3>
                            <h4 className="project__cat-s">#THREEJS, #GSAP, #DESIGN</h4>
                            <h5 className="project__cat-y">2022</h5>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div id="project-image" className="col-12 p-0 position-relative">
                            <img className="img-fluid invisible" src={pimage} alt="Project" />
                            <img data-scroll="" data-scroll-class="in-view" className="img-fluid canvas-image invisible" src={pimage} alt="Project" />
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <div className="project__intro">
                                Studio NFT guide you through the process of understanding exactly what you can do with NFT technology in order maximize their fan/audience
                                impact, brand-engagement, and revenue.
                            </div>
                            <a className="project__link fs" target="_blank" href="https://studionft.com/">Navigate webiste</a>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <div className="row">
                                <div className="col-6">
                                    <div className="position-relative">
                                        <img className="img-fluid invisible position-relative" src={pimage1} alt="Project" />
                                        <img data-scroll="" data-scroll-speed="1" data-scroll-class="in-view" className="img-fluid canvas-image invisible" src={pimage1} alt="Project" />
                                    </div>
                                </div>
                                <div className="col-6 project__img--2">
                                    <div className="position-relative">
                                        <img className="img-fluid invisible" src={pimage2} alt="Project" />
                                        <img data-scroll="" data-scroll-speed="-1" data-scroll-class="in-view" className="img-fluid canvas-image invisible" src={pimage2} alt="Project" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center project__desc-wrap">
                        <div className="col-12 col-lg-8">
                            <div className="row">
                                <div className="col-lg-8 offset-lg-2">
                                    <h2 className="project__desc-t">IMMERSIVE DIGITAL EXPERIENCE DRIVING USER INSIDE THE BLOCKCHAIN WORLD</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-7 offset-lg-4">
                                    <div className="project__desc">
                                        Being able to bring the user in a new world through details and interactions, this was the exciting challenge that the studioNFT presented to me during the breefing of the project.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <video data-scroll="" data-scroll-class="in-view" id="project-video" className="img-fluid invisible project-video" loop={true} crossOrigin="" autoPlay={true} muted={true} playsInline={true} >
                                <source src={pvideo} type="video/mp4" />
                            </video>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <div className="project__end"></div>
                        </div>
                    </div>
                    <div className="row">
                        <a href="/lorrive/" onClick={e => { e.preventDefault(); siteNav.nav('/lorrive/'); }} className="col-12 p-0 project__next-wrap" data-scroll data-scroll-class="in-view">
                            <img src={nextprojectSVG} className="img-fluid project__next invisible" alt="" /><br />
                        </a>
                    </div>
                </div>
                <Footer />

            </>
        )
    }
}

export default NamikoPage
